import React from 'react';
import styles from './BetaBadge.module.css';
import IconRocket from '../icons/IconRocket';
import { Tooltip } from '../Tooltip/Tooltip';

interface BetaBadgeProps {
  className?: string;
  text?: string;
}

/**
 * BetaBadge component that displays a "BETA" label with a rocket icon
 * Used to indicate features that are in beta testing
 */
const BetaBadge: React.FC<BetaBadgeProps> = ({ className = '', text = 'BETA' }) => {
  return (
    <Tooltip title="This page is currently in beta. Please report any issues you encounter to our support team" placement="auto">
      <span className={`${styles.betaBadge} ${className}`}>
        <IconRocket size={18} className={styles.betaIcon} />
        {text}
      </span>
    </Tooltip>
  );
};

export default BetaBadge;